/* eslint-disable import/prefer-default-export */

export function setUrl(val) {
  const baseUrl = {
    localhost: `https://school${val}.school.yunkeduntest.com`,
    'management.schoolweb.yunkeduntest.com': `https://school${val}.school.yunkeduntest.com`,
    'management.schoolweb.yunkedun.com': `https://school${val}.school.yunkedun.com`,
  };
  return baseUrl[window.location.hostname];
}



// WEBPACK FOOTER //
// ./src/utils/schoolUrl.js